const semanticClassNames = {
  root: 'upload-button',
  icon: 'upload-button__icon',
  label: 'upload-button__label',
  fieldTitle: 'upload-button__field-title',
} as const;

export default semanticClassNames;
